import { render } from "./UserPasswordReset.vue?vue&type=template&id=02d1423b&scoped=true"
import script from "./UserPasswordReset.vue?vue&type=script&lang=js"
export * from "./UserPasswordReset.vue?vue&type=script&lang=js"

import "./UserPasswordReset.vue?vue&type=style&index=0&id=02d1423b&scoped=true&lang=css"

import exportComponent from "/home/gbl/SoftwareProjects/MyProjects/UniStuttgart/truscanWebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d1423b"]])

export default __exports__